import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/services/api';

/**
 * Lê o flag de feature do plano corrente do tenant. Master admin sempre
 * passa. Útil pra esconder/desbloquear UI; o backend faz o gating real.
 */
export function usePlanFeature(featureKey: string): { enabled: boolean; isLoading: boolean } {
  const { data: tenant, isLoading } = useQuery({
    queryKey: ['tenant'],
    queryFn: () => apiClient.getTenant().then(r => r.data),
    staleTime: 60 * 1000,
  });

  if (!tenant) return { enabled: false, isLoading };

  const features = tenant.current_plan?.features;
  // features vem como string JSON (Plan.Features é jsonb mapeado pra string no .NET)
  if (typeof features === 'string') {
    try {
      const parsed = JSON.parse(features);
      return { enabled: parsed?.[featureKey] === true, isLoading };
    } catch {
      return { enabled: false, isLoading };
    }
  }
  if (features && typeof features === 'object') {
    return { enabled: (features as any)[featureKey] === true, isLoading };
  }
  return { enabled: false, isLoading };
}
